import { Component, Element, h, Host, Prop, State } from '@stencil/core';
import { ICON_SIZES, ICON_TYPES, IconColors, IconSize, IconType } from './models/icon.types';

@Component({
  tag: 'wink-icon',
  styleUrl: 'styles/icon.default.scss',
  shadow: true,
})
export class Icon {
  @Element() host!: HTMLWinkIconElement;

  @Prop({ reflect: true }) appearance: IconType = ICON_TYPES.default;
  @Prop() size: IconSize = ICON_SIZES.md;
  @Prop() icon = 'bell';
  @Prop() iconColor?: IconColors;

  @State() hasBackdrop = false;

  componentWillRender(): void {
    this.hasBackdrop = this.appearance !== 'default' && Object.values(ICON_TYPES).includes(this.appearance);
  }

  private getBackdropClass(): string {
    if (this.hasBackdrop) {
      return 'backdrop';
    }
    return '';
  }

  render() {
    return (
      <Host part={this.getBackdropClass()} class={this.getBackdropClass()} exportparts={`icon, icon-${this.icon}`}>
        <i
          class={{
            [this.size]: true,
            [this.appearance]: true,
            ['backdrop']: this.hasBackdrop,
            ['color--' + this.iconColor]: this.appearance === ICON_TYPES.default && this.iconColor !== undefined,
          }}
          part={`icon icon-${this.icon}`}
          aria-hidden="true"
        />
      </Host>
    );
  }
}
